var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { TextField, Grid } from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";
var FormInput = function (_a) {
    var name = _a.name, label = _a.label;
    var _b = useFormContext(), register = _b.register, errors = _b.formState.errors, control = _b.control;
    return (React.createElement(Grid, { item: true, xs: 12, sm: 6 },
        React.createElement(Controller, { control: control, name: name, render: function (_a) {
                var _b;
                var field = _a.field;
                return (React.createElement(TextField, __assign({}, register(name, { required: "This field is required" }), field, { fullWidth: true, label: label, error: Boolean(errors[name]), helperText: errors[name] && String((_b = errors[name]) === null || _b === void 0 ? void 0 : _b.message) })));
            } })));
};
export default FormInput;
